import React, {useRef} from 'react';
import {Link} from 'react-router-dom';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
const CardItems = [
  {
    img: '418',
    likes: '1.2',
    title: 'Weedheads #418',
    avatar_img1: '1',
    avatar_img2: '2',
    avatar_name: 'ILOVETRAINS!',
    price: '1',
    hight_price: '6.122',
  },
  {
    img: '2',
    likes: '3.5',
    title: 'Weedheads #2',
    avatar_img1: '3',
    avatar_img2: '4',
    avatar_name: 'VaxaVidr',
    price: '3.5',
    hight_price: '5.475',
  },
  {
    img: '3',
    likes: '2.4',
    title: 'Weedheads #3',
    avatar_img1: '5',
    avatar_img2: '1',
    avatar_name: 'Alexander🦈Boasie',
    price: '8',
    hight_price: '7.674',
  },
  {
    img: '38',
    likes: '2.1',
    title: 'Weedheads #38',
    avatar_img1: '4',
    avatar_img2: '5',
    avatar_name: 'wakuwaku',
    price: '2',
    hight_price: '9.963',
  },
  {
    img: '5',
    likes: '1.6',
    title: 'Weedheads #5',
    avatar_img1: '2',
    avatar_img2: '4',
    avatar_name: 'whelan',
    price: '6.3',
    hight_price: '11.354',
  },
  {
    img: '200',
    likes: '3.7',
    title: 'Weedheads #200',
    avatar_img1: '1',
    avatar_img2: '3',
    avatar_name: 'KingMango',
    price: '3.4',
    hight_price: '5.784',
  },
  {
    img: '43',
    likes: '2.3',
    title: 'Weedheads #43',
    avatar_img1: '1',
    avatar_img2: '2',
    avatar_name: 'machomigoo',
    price: '1',
    hight_price: '6.122',
  },
  {
    img: '77',
    likes: '3.9',
    title: 'Weedheads #77',
    avatar_img1: '3',
    avatar_img2: '4',
    avatar_name: 'VaxaVidr',
    price: '3.5',
    hight_price: '5.475',
  },
  {
    img: '335',
    likes: '1.1',
    title: 'Weedheads #335',
    avatar_img1: '5',
    avatar_img2: '2',
    avatar_name: 'Shaman',
    price: '8',
    hight_price: '7.674',
  },
  {
    img: '248',
    likes: '3.3',
    title: 'Weedheads #248',
    avatar_img1: '4',
    avatar_img2: '1',
    avatar_name: 'ILOVETRAINS!',
    price: '2',
    hight_price: '9.963',
  },
  {
    img: '417',
    likes: '2.5',
    title: 'Weedheads #417',
    avatar_img1: '2',
    avatar_img2: '4',
    avatar_name: 'Alexander🦈Boasie',
    price: '6.3',
    hight_price: '11.354',
  },
  {
    img: '243',
    likes: '3.4',
    title: 'Weedheads #243',
    avatar_img1: '1',
    avatar_img2: '3',
    avatar_name: 'wakuwaku',
    price: '3.4',
    hight_price: '5.784',
  },
];

const CardProfile = () => {
  const ref = useRef();
  const closeTooltip = () => ref.current.close();
  return (
    <div className="row mb-30_reset">
      {CardItems.map((val, i) => (
        <div className="col-xl-4 col-lg-6 col-md-6" key={i}>
          <div className="card__item three">
            <div className="card_body space-y-10">
              {/* =============== */}
              <div className="card_head">
                <img src={`img/weedheads/${val.img}-min.png`} alt="nftimage" />
                <Link to="#" className="likes space-x-3">
                  <i className="ri-heart-3-fill" />
                  <span className="txt_sm">{val.likes}k</span>
                </Link>
                <div className="action">
                  <Popup
                    className="custom"
                    ref={ref}
                    trigger={
                      <button className="btn btn-sm btn-primary btn_auction">
                        <i className="ri-auction-line color_white mr-5px" />
                        Place Your Bid
                      </button>
                    }
                    position="bottom center">
                    <div>
                      <div
                        className="popup"
                        id="popup_bid"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true">
                        <div>
                          <button
                            type="button"
                            className="button close"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={closeTooltip}>
                            <span aria-hidden="true">×</span>
                          </button>
                          <div className=" space-y-20">
                            <h3>Place a Bid</h3>
                            <p>
                              You must bid at least
                              <span className="color_black">15 ETH</span>
                            </p>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="00.00 ETH"
                            />
                            <p>
                              Enter quantity.
                              <span className="color_green">5 available</span>
                            </p>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={1}
                            />
                            <div className="hr" />
                            <div className="d-flex justify-content-between">
                              <p> You must bid at least:</p>
                              <p className="text-right color_black txt _bold">
                                67,000 ETH
                              </p>
                            </div>
                            <div className="d-flex justify-content-between">
                              <p> service free:</p>
                              <p className="text-right color_black txt _bold">
                                0,901 ETH
                              </p>
                            </div>
                            <div className="d-flex justify-content-between">
                              <p> Total bid amount:</p>
                              <p className="text-right color_black txt _bold">
                                56,031 ETH
                              </p>
                            </div>
                            <Popup
                              className="custom"
                              ref={ref}
                              trigger={
                                <button className="btn btn-primary w-full">
                                  Place a bid
                                </button>
                              }
                              position="bottom center">
                              <div>
                                <div
                                  className="popup"
                                  id="popup_bid"
                                  tabIndex={-1}
                                  role="dialog"
                                  aria-hidden="true">
                                  <div>
                                    <button
                                      type="button"
                                      className="button close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                      onClick={closeTooltip}>
                                      <span aria-hidden="true">×</span>
                                    </button>
                                    <div className="space-y-20">
                                      <h3 className="text-center">
                                        Your Bidding Successfuly Added
                                      </h3>
                                      <p className="text-center">
                                        your bid
                                        <span
                                          className="color_text txt
      _bold">
                                          (16ETH)
                                        </span>
                                        has been listing to our database
                                      </p>
                                      <Link
                                        to="#"
                                        className="btn btn-dark w-full">
                                        Watch the listings
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Popup>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Popup>
                </div>
              </div>
              {/* =============== */}
              <h6 className="card_title">
                <Link className="color_black" to={"item-details/" + val.img}>
                  {val.title}
                </Link>
              </h6>
              <div className="card_footer d-block space-y-10">
                <div
                  className="
															d-flex
															justify-content-between
															align-items-center
														">
                  <div className="creators space-x-10">
                    <div className="avatars -space-x-20">
                      <Link to="profile">
                        <img
                          src={`img/nfteaseavs/${val.avatar_img1}.svg`}
                          alt="Avatar"
                          className="avatar avatar-sm"
                        />
                      </Link>
                      <Link to="profile">
                        <img
                          src={`img/nfteaseavs/${val.avatar_img2}.svg`}
                          alt="Avatar"
                          className="avatar avatar-sm"
                        />
                      </Link>
                    </div>
                    <Link to="profile">
                      <p className="avatars_name txt_sm">
                        {val.avatar_name} ..
                      </p>
                    </Link>
                  </div>
                  <Link to="#" className="space-x-3">
                    <p className="color_green txt_sm">{val.price} SOL</p>
                  </Link>
                </div>
                <div className="hr" />
                <div className="d-flex align-items-center space-x-10">
                  <i className="ri-vip-crown-line" />
                  <p className="color_text txt_sm" style={{width: 'auto'}}>
                    Price
                  </p>
                  <span className="color_black txt_sm">
                    {val.hight_price} SOL
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardProfile;
